import { Modal, Space, Button, Flex } from "antd";
import React, { ReactNode } from "react";
import noticePic from "@/assets/img/notice.png"; 
export interface CustomModalProps {
  /**
   * 弹窗标题
   */
  title?: string;
  /**
   * 是否显示弹窗
   */
  open: boolean;
  /**
   * 确认按钮文本
   */
  okText?: string;
  /**
   * 取消按钮文本
   */
  cancelText?: string;
  /**
   * 确认按钮加载状态
   */
  confirmLoading?: boolean;
  /**
   * 点击确定回调
   */
  onOk?: () => void;
  /**
   * 点击取消回调
   */
  onCancel?: () => void;
  /**
   * 弹窗宽度
   */
  width?: number | string;
  /**
   * 是否显示右上角关闭按钮
   */
  closable?: boolean;
  /**
   * 是否点击蒙层关闭
   */
  maskClosable?: boolean;
  /**
   * 底部内容，当不需要默认底部按钮时，可以设为 null
   */
  footer?: ReactNode;
  /**
   * 确认按钮的props
   */
  okButtonProps?: any;
  /**
   * 取消按钮的props
   */
  cancelButtonProps?: any;
  /**
   * 垂直居中展示
   */
  centered?: boolean;
  /**
   * 弹窗内容（插槽）
   */
  children?: ReactNode;
  /**
   * 自定义类名
   */
  className?: string;
  /**
   * 关闭时销毁子元素
   */
  destroyOnHidden?: boolean;
}

const CustomModal: React.FC<CustomModalProps> = ({
  title = "提示",
  open,
  okText = "确定",
  cancelText = "取消",
  confirmLoading = false,
  onOk,
  onCancel,
  width = 400,
  closable = true,
  maskClosable = false,
  okButtonProps,
  cancelButtonProps,
  centered = true,
  children,
  className = "",
  destroyOnHidden = true,
}) => {
  const footer = (
    <>
      <Space>
        {onCancel && (
          <Button onClick={onCancel} className="btn-2">
            {cancelText}
          </Button>
        )}
        {onOk && (
          <Button type="primary" onClick={onOk}>
            {okText}
          </Button>
        )}
      </Space>
    </>
  );
  return (
    <Modal
      title={title}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      confirmLoading={confirmLoading}
      width={width}
      closable={closable}
      maskClosable={maskClosable}
      footer={footer}
      okButtonProps={okButtonProps}
      cancelButtonProps={cancelButtonProps}
      centered={centered}
      className={className}
    >
      <div className="content mt-30" style={{marginBottom:'67px'}}>
        <Flex align="center" gap={16}>
          <div className="left">
            <img src={noticePic} alt="" style={{width:'30px',height:'30px'}} />
          </div>
          <div className="right">
            <div className="line1 font-15 color-3" >确认删除？</div>
            <div className="line2 font-12 color-9 mt-2">即将永久删除数据，是否确认删除？</div>
          </div>
        </Flex>
      </div>
    </Modal>
  );
};

export default CustomModal;
